const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__logoContainer">
                <div className="footer__logo" />
            </div>
        </footer>
    )
}

export default Footer
